import { Trans } from '@lingui/react/macro';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SelectEmptyProps = ComponentProps<'div'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any[] | undefined;
};

const SelectEmpty = ({ className, items, children, ...props }: SelectEmptyProps) => {
  const isEmpty = !items || items.length === 0;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={cn(
        'flex items-center gap-2 px-3 py-2 text-sm text-gray-500 italic empty:hidden',
        className,
      )}
      {...props}
    >
      {isEmpty && (children ?? <Trans>No results found...</Trans>)}
    </div>
  );
};

export default SelectEmpty;
